<template>
  <div>
    <form-field-address
        :entity="form"
        include-county
        include-line2
        :validation-errors="validationErrors"
    ></form-field-address>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "PropertyForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        line_1: null,
        line_2: null,
        city: null,
        county: null,
        state: null,
        postcode: null,
        postcode_ext: null,
        country_code: null,
      },
    }
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    update() {
      return this.$api.properties.updateAddress(this.form)
      .then(res => {
        this.$buefy.toast.open({
          message: 'Property was updated',
          type: 'is-success'
        });

        return res;
      });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
